import { Box, Button, TextField } from '@mui/material';
import { Avatar, Grid, Typography } from '@mui/material/node';
import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { UserAvatar } from './userAvatar';
import { CloudQueue, CloudUpload } from '@mui/icons-material';
import { styled } from '@mui/material/node/styles';
import {storage} from './../../../config/firebase';
import {getDownloadURL, ref, uploadBytes} from 'firebase/storage';
import Resizer from "react-image-file-resizer";

export const ProfileDetails = (props) => {
    const navigate = useNavigate();
    const [userData, setUserData] = React.useState({
        name: props.userData?.name,
        bio: props.userData?.bio,
        picurl: props.userData?.picurl
    });
    const [imageUpload, setImageUpload] = React.useState(null);
    const [nameError, setNameError] = React.useState(false);
    const inputNameRef = React.useRef(null);

    const submitForm = (event) => {
        event.preventDefault();
        if (!event.target[0].validity.valid) {
            setNameError(true);
            event.target[0].focus();
            return;
        }

        handleSave();
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (e.target.validity.valid) {
            setNameError(false);
        } else {
            setNameError(true);
        }

        setUserData((prev) => {
            return { ...prev, [name]: value }
        });
    };

    const handleSave = (e) => {
        if (!e) {
            props.saveProfile(userData);
            return;
        }

        e.preventDefault();

        if (e.target.validity.valid) {
            setNameError(false);
            props.saveProfile(userData);
        } else {
            setNameError(true);
        }
    };

    const resizeAndUploadPic = (file) => {
        
        Resizer.imageFileResizer(
            file,
            128,
            128,
            "JPEG",
            80,
            0,
            (resizedPicUri) => {
                uploadImage(resizedPicUri);
            },
            "base64",
            64,
            64
          );
    }

    const uploadImage = async (uri) => {
        if (uri == null) return;

        const blob = await fetch(uri).then((r) => r.blob());
        const fileFromBlob = new File([blob], "example.png");
        const imageRef = ref(storage, `avatars/${props.uid}.jpeg`);

        uploadBytes(imageRef, fileFromBlob).then(() => {
            getDownloadURL(imageRef).then((url) => {
                setUserData({...userData, picurl: url});
                handleSave();
            })
        });
    }

    const handleMyProjects = () => {
        navigate("/myprojects");
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    return (
        <Box sx={{ pt: 10, pb: 10 }} display="grid"
            justifyContent="center"
            alignItems="center" >
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    boxShadow: 1,
                    borderRadius: 2,
                    p: 2,
                    mx: 2,
                    Width: 400,
                    maxWidth: 450
                }}
            >
                <Grid container>
                    <Grid item xs={4}>
                        <UserAvatar userData={userData}/>
                    </Grid>
                    <Grid item xs={8} >
                        <Box sx={{ color: 'text.secondary', display: 'inline', width: '100%', fontSize: 14, mx: '4px' }}>
                            <Typography variant="h4" align="left">{props.userData?.name}</Typography>
                            <Typography variant="body1" align="left" sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 3,
                            }}>{props.userData?.bio}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} align="center"  >
                        <Button
                            component="label"
                            size='small'
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUpload />}
                            onChange={(event) => {resizeAndUploadPic(event.target.files[0])}}
                        >
                            Upload avatar
                            <VisuallyHiddenInput type="file" accept="image/jpeg, image/png"/>
                        </Button>
                    </Grid>
                </Grid>
            </Box>

            <Box
                component="form"
                autoComplete="off"
                onSubmit={submitForm}
                noValidate
                sx={{
                    p: 2,
                    mx: 2,
                    Width: 400,
                    maxWidth: 450
                }}
            >
                <TextField
                    id="name"
                    name="name"
                    variant="outlined"
                    label="Name"
                    ref={inputNameRef}
                    fullWidth
                    required
                    
                    sx={{ my: 2 }}
                    value={userData?.name ?? ''}
                    onChange={handleChange}
                    error={nameError}
                    helperText={nameError ? "Please enter your name" : ""} >
                </TextField>
                <TextField
                    id="bio"
                    name="bio"
                    variant="outlined"
                    label="Bio"
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ maxLength: 200 }}
                    sx={{ my: 2 }}
                    value={userData?.bio ?? ''}
                    onChange={handleChange} >
                </TextField>
                {/* <Typography align="left">E-mail</Typography> */}

                <TextField
                    variant="outlined"
                    disabled
                    size='small'
                    label="e-mail"
                    fullWidth sx={{ my: 2 }}
                    value={props?.email ?? ''}>

                </TextField>
                <Button variant="contained" fullWidth type='submit'>Save</Button>
            </Box>
            <Box
                sx={{
                    p: 2,
                    mx: 2,
                    Width: 400,
                    maxWidth: 450
                }}
            >
                <Button variant="contained" fullWidth onClick={handleMyProjects}>My Projects</Button>
            </Box>

            {/* <Button variant="contained" color="error" fullWidth sx={{ my: 1 }}>Delete Account</Button> */}

        </Box>

    );
}